import { render } from "./leader.vue?vue&type=template&id=6d058eac&scoped=true"
import script from "./leader.vue?vue&type=script&lang=js"
export * from "./leader.vue?vue&type=script&lang=js"

import "./leader.vue?vue&type=style&index=0&id=6d058eac&lang=css"
import "./leader.vue?vue&type=style&index=1&id=6d058eac&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d058eac"]])

export default __exports__